// extracted by mini-css-extract-plugin
module.exports = {"content":"notfound_content__3Eo_9","title":"notfound_title__1xcu_","text":"notfound_text__1asXB"};